import React from "react";
import {
	BrowserRouter as Router,
	Routes,
	Route,
	Navigate,
} from "react-router-dom";

// Pay-by-minute
import Registration from "./pages/payByMinute/Registration";
import PaymentCapture from "./pages/payByMinute/PaymentCapture";
import SessionSetup from "./pages/payByMinute/SessionSetup";
import Checkout from "./pages/payByMinute/Checkout";

// Reservation
import TimeScheduler from "./pages/reservation/time/TimeScheduler";
import SelectBox from "./pages/reservation/booth/SelectBox";
import BoothConfirmation from "./pages/reservation/booth/BoothConfirmation";
import StartSession from "./pages/reservation/sign-up/StartSession";

import Reservation from "./pages/reservation/reservation/Reservation";
import SessionCancel from "./pages/reservation/reservation/SessionCancel";
import BoothLanding from "./pages/BoothLanding";
import BoothPage from "./pages/BoothPage";
import WalkUpCheckin from "./pages/WalkUpCheckin";
import NotFound from "./pages/NotFound";

// Dev
import Dev from "./pages/Dev";

const env = process.env.REACT_APP_ENV;

export default function App() {
	return (
		<Router>
			<Routes>
				{/* Booth Pages - New unified booth experience */}
				<Route path="/booth/:boothId" element={<BoothPage />} />
				<Route path="/booth/:boothId/checkin" element={<WalkUpCheckin />} />

				{/* Legacy Booth QR Code Landing - redirects to new booth page */}
				<Route path="/book/:boothId" element={<BoothLanding />} />

				{/* Pay-by-minute */}
				<Route path="/register" element={<Registration />} />
				<Route path="/payment-capture" element={<PaymentCapture />} />
				<Route path="/session/new" element={<SessionSetup />} />
				<Route path="/checkout/:token" element={<Checkout />} />

				{/* Reservation */}
				<Route
					path="/:locationId/reservation/time-scheduler"
					element={<TimeScheduler />}
				/>
				<Route
					path="/:locationId/:id/reservation/time-scheduler/"
					element={<TimeScheduler />}
				/>
				<Route
					path="/reservation"
					element={
						<Navigate to="/:locationId/reservation/time-scheduler" replace />
					}
				/>
				<Route
					path="/:locationId/reservation/select-box"
					element={<SelectBox />}
				/>
				<Route
					path="/:locationId/reservation/booth-confirmation"
					element={<BoothConfirmation />}
				/>
				<Route
					path="/:locationId/reservation/start-session"
					element={<StartSession />}
				/>

				<Route
					path="/reservation/session/:sessionId"
					element={<Reservation />}
				/>
				<Route
					path="/reservation/session-cancel/:sessionId"
					element={<SessionCancel />}
				/>

				<Route
					path="/"
					element={
						<Navigate to="/0500550214/reservation/time-scheduler" replace />
					}
				/>

				{env === "development" && <Route path="/dev" element={<Dev />} />}

				{/* 404 - Must be last to catch all unmatched routes */}
				<Route path="*" element={<NotFound />} />
			</Routes>
		</Router>
	);
}
